import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, debounceTime, filter, Observable } from 'rxjs';
import { SmartAction, View } from '../../../../../../shared/store/view/types';
import { SearchService } from '../../../../../../shared/store/search/search.service';
import { ViewService } from '../../../../../../shared/store/view/views.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommissionService } from '../../../../../../shared/store/commissions/commission/commission.service';
import { Router } from '@angular/router';
import { Filter } from '../../../../../../shared/store/search/types';
import { CommissionReportSalesPersonProductionDashboardModel } from '../../../../../../shared/store/commissions/commission/types';

@UntilDestroy()
@Component({
  selector: 'app-sales-person-production-dashboard',
  standalone: false,
  templateUrl: './sales-person-production-dashboard.component.html',
  styleUrl: './sales-person-production-dashboard.component.scss',
})
export class SalesPersonProductionDashboardComponent
  implements OnInit, OnDestroy
{
  data$: Observable<CommissionReportSalesPersonProductionDashboardModel>;
  view$: Observable<View>;

  smartAction: SmartAction;

  constructor(
    private readonly searchService: SearchService,
    private readonly viewService: ViewService,
    private readonly commissionService: CommissionService,
    private readonly router: Router,
  ) {
    this.view$ = this.viewService.getViews.value$;
    this.data$ =
      this.commissionService.getSalesPersonProductionDashboardData.value$;
  }

  ngOnInit(): void {
    combineLatest([this.view$, this.searchService.getActiveFilters()])
      .pipe(
        filter(([view, activeFilter]) => !!view && !!activeFilter),
        debounceTime(200),
        untilDestroyed(this),
      )
      .subscribe(([view, activeFilters]) => {
        this.commissionService.getSalesPersonProductionDashboardData.call(
          activeFilters,
        );
      });

    this.smartAction = {
      id: 'contracts',
      label: 'Contracts',
      url: '/Insurance/Contracts/List',
      count: 0,
      filter: <Filter>{},
      icon: '',
      actif: true,
      singleId: '',
    };
  }

  ngOnDestroy(): void {
    this.commissionService.getSalesPersonProductionDashboardData.reset();
  }

  onSmartLinkClick(smartAction: SmartAction, filter: Filter): void {
    this.searchService.temporaryKeepActiveFilters(
      this.router.url,
      smartAction.url,
    );

    this.smartAction.filter = filter;

    this.searchService.addActiveFilter(smartAction.filter, true);
    this.searchService.resetActiveFilter();

    this.router.navigate([smartAction.url], {
      state: { useTempFilter: true },
    });
  }
}
